var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_482_18105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0924 0C5.92411 0 0.0922852 5.83183 0.0922852 12.9999C0.0922852 20.168 5.92411 26 13.0924 26C20.2606 26 26.0925 20.1682 26.0925 12.9999C26.0925 5.83164 20.2605 0 13.0924 0ZM13.0924 23.2621C7.43377 23.2621 2.83015 18.6585 2.83015 12.9999C2.83015 7.34148 7.43377 2.73786 13.0924 2.73786C18.751 2.73786 23.3546 7.34148 23.3546 12.9999C23.3544 18.6585 18.751 23.2621 13.0924 23.2621Z",
    fill: "#FF3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4773 6.61493C18.9425 6.0805 18.0759 6.0805 17.5413 6.61493L13.0532 11.1028L8.63045 6.67991C8.09584 6.14548 7.22921 6.14548 6.69442 6.67991C6.1598 7.21471 6.1598 8.08133 6.69442 8.61595L11.1172 13.0387L6.7594 17.3964C6.22478 17.9312 6.22478 18.7979 6.7594 19.3325C7.02679 19.5997 7.37706 19.7333 7.7275 19.7333C8.07777 19.7333 8.42821 19.5997 8.69561 19.3325L13.0532 14.9749L17.4759 19.3976C17.7433 19.6649 18.0936 19.7985 18.444 19.7985C18.7943 19.7985 19.1447 19.6649 19.4121 19.3976C19.9468 18.8628 19.9468 17.9962 19.4121 17.4616L14.9894 13.0389L19.4773 8.55097C20.0119 8.01617 20.0119 7.14955 19.4773 6.61493Z",
    fill: "#FF3A3A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_482_18105"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(0.0922852)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosed);
export default __webpack_public_path__ + "static/media/closed.1643e71b4011ed2d3c7c332d5b31dba0.svg";
export { ForwardRef as ReactComponent };